<template>
  <div>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-layout class="mt-5 mb-2">
      <v-flex lg7>
        <Validate :v="$v.form.identificadorpreparacao">
          <v-autocomplete
            slot-scope="{ props }"
            v-bind="props"
            v-model="form.identificadorpreparacao"
            :items="preparacaoOptions"
            outlined
            label="Preparação*"
            :no-data-text="preparacoesLoading ? 'Carregando dados, aguarde...' : preparacaoSearch ? `Nenhuma opção encontrada com '${preparacaoSearch}'` : 'Nenhuma opção carregada'"
            :search-input.sync="preparacaoSearch"
            :loading="preparacoesLoading"
            loader-height="3"
            @focus="carregaPreparacao"
            @change="carregarComposicaoPreparacao"
            :disabled="loading"
            :background-color="loading ? '#f2f2f2' : null">
          </v-autocomplete>
        </Validate>
      </v-flex>
    </v-layout>

    <v-card class="mt-5 px-2 pt-2">
      <v-container grid-list-lg>
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="6" class="col-xs-12">
            <Validate :v="$v.form.alimento.identificadorcomposicaoalimentopadrao">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.alimento.identificadorcomposicaoalimentopadrao"
                  :items="alimentoOptions"
                  item-text="value"
                  item-value="key"
                  outlined
                  label="Alimento*"
                  :no-data-text="alimentosLoading ? 'Carregando dados, aguarde...' : alimentoSearch ? `Nenhuma opção encontrada com '${alimentoSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="alimentoSearch"
                  :loading="alimentosLoading"
                  loader-height="3"
                  :disabled="form.identificadorpreparacao == '' || modoTela == 'edicao' || loading"
                  :background-color=" form.identificadorpreparacao == '' || modoTela == 'edicao' || loading ? '#f2f2f2' : null"
                ></v-autocomplete>
              </Validate>
            </v-col>
            <v-col cols="12" md="6" lg="2" class="pl-md-4 pl-lg-0 pl-lg-4">
              <Validate :v="$v.form.quantidade">
                <v-text-field
                  slot-scope="{ props }"
                  v-bind="props"
                  label="Quantidade Per Capita*"
                  v-model="form.quantidade"
                  outlined
                  :disabled="!form.alimento.identificadorcomposicaoalimentopadrao || loading"
                  :background-color="!form.alimento.identificadorcomposicaoalimentopadrao || loading ? '#f2f2f2' : null">
                </v-text-field>
              </Validate>
            </v-col>
            <v-col cols="12" md="6" lg="2" class="pl-lg-4">
              <Validate :v="$v.form.unidade">
                <v-select
                  v-model="form.unidade"
                  :items="unidadeOptions"
                  item-text="value"
                  item-value="key"
                  label="Unidade*"
                  outlined
                  menu-props="offsetY"
                  :disabled="!form.alimento.identificadorcomposicaoalimentopadrao || loading"
                  :background-color="!form.alimento.identificadorcomposicaoalimentopadrao || loading ? '#f2f2f2' : null">
                </v-select>
              </Validate>
            </v-col>
            <v-col cols="12" md="6" lg="2" class="pl-md-4 px-lg-0 pl-lg-4">
              <v-select
                v-model="form.complemento"
                :items="complementoOptions"
                item-text="value"
                item-value="key"
                clearable
                label="Complemento"
                outlined
                menu-props="offsetY"
                :disabled="form.unidade == null || modoTela == 'edicao' || loading"
                :background-color="form.unidade == null || modoTela == 'edicao' || loading ? '#f2f2f2' : null">
              </v-select>
            </v-col>
            <!-- <v-col cols="12" md="2" lg="2" class="pl-lg-4" >
              <v-btn style="margin-top:10px;" width="100%" v-if="modoTela != 'edicao'" type="button" class="mb-3" color="cyan" :dark="loading || form.quantidade == '' || form.unidade == null ? false : true" :loading="loading" :disabled="(form.quantidade == '' || form.unidade == null) || loading" @click="adicionarAlimento()">+ Adicionar</v-btn>
              <v-btn width="100%" v-if="modoTela == 'edicao'" type="button" class="mb-3" color="cyan" :dark="!loading" @click="salvarEdicaoAlimento(alimentoEmEdicao)" :loading="loading" :disabled="loading"> Alterar</v-btn>
              <v-btn width="100%" v-if="modoTela == 'edicao'" type="button" class="mb-3" color="cyan" :dark="!loading" @click="cancelarAlteracao()" :disabled="loading"> Cancelar</v-btn>
            </v-col> -->
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" align="right">
              <v-btn v-if="modoTela != 'edicao'" type="button" color="cyan" small :dark="loading || form.quantidade == '' || form.unidade == null ? false : true" :loading="loading" :disabled="(form.quantidade == '' || form.unidade == null) || loading" @click="adicionarAlimento()">Incluir</v-btn>
              <v-btn v-if="modoTela == 'edicao'" type="button"  color="cyan" small :dark="!loading" @click="salvarEdicaoAlimento(alimentoEmEdicao)" :loading="loading" :disabled="loading"> Alterar</v-btn>
              <v-btn v-if="modoTela == 'edicao'" type="button" class=" ml-3" color="cyan" small :dark="!loading" @click="cancelarAlteracao()" :disabled="loading"> Cancelar</v-btn>
            </v-col>
          </v-row>
        <v-layout row>
          <v-flex xs12 pt-5 style="overflow-y: auto">
            <table class="table-siged" id="composicao_preparacao_table">
          <thead>
            <tr>
              <th>Alimento</th>
              <th>Quantidade</th>
              <th>Fonte</th>
              <th style="min-width:70px;">CHO (g)</th>
              <th style="min-width:70px;">PTN (g)</th>
              <th style="min-width:70px;">LIP (g)</th>
              <th style="min-width: 150px;">Valor Calórico (Kcal)</th>
              <th style="min-width: 85px;">Vit. A (RE)</th>
              <th style="min-width: 70px;">Fe (mg)</th>
              <th style="min-width: 70px;">Ca (mg)</th>
              <th style="min-width: 80px;">Fib. Total</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 80px;">G. Poli (g)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 95px;">G. Mono (g)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 80px;">G. Sat (g)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 85px;">Fib. Sol (g)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 85px;">Fib. Ins (g)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 65px;">Col. (g)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 95px;">Vit. B1 (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 95px;">Vit. B2 (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 95px;">Vit. B3 (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 95px;">Vit. B5 (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 95px;">Vit. B6 (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 100px;">Vit. B9 (mcg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 105px;">Vit. B12 (mcg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 85px;">Vit. C (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 95px;">Vit. D (mcg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 85px;">Vit. E (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 70px;">I (mcg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 70px;">Na (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 72px;">Mg (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 70px;">Zn (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 72px;">Mn (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 70px;">K (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 70px;">P (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 70px;">Cu (mg)</th>
              <th v-show="mostrarTabelaCompleta" style="min-width: 75px;">Se (mcg)</th>
              <th style="width: 120px;">Ação</th>
            </tr>
          </thead>
          <tbody style="white-space: nowrap;">

            <template v-for="parte in composicao.reduce((total, current) => {
              if (  !total.includes(current.complemento) )
                total.push(current.complemento)
                return total
            }, [] ).sort((a,b) => {
                    if (a == null) return -1
                    if (b == null) return 1
                    return 0
                  })">
              <tr v-if="parte != null && complementoOptions[parte]">
                <td style="font-weight: bold;" colspan="37">
                  {{ complementoOptions[parte].value }}
                </td>
              </tr>

              <tr v-for="alimento in composicao.filter( (alimento) => alimento.complemento == parte)" :key="alimento.identificadorcomposicaoalimentopadrao + '' + alimento.complemento">
                <td>{{alimento.descricaocomposicaoalimentopadrao}}</td>
                <td class="text-align__center">{{alimento.quantidade.toString().replace(',', '.')}} {{alimento.unidade}}</td>
                <td class="text-align__center">{{alimento.indicaorigemalimentoexterno}}</td>
                <td class="text-align__center" :title="alimento.quantidadecarboidrato">{{Number(alimento.quantidadecarboidrato).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadeproteina">{{Number(alimento.quantidadeproteina).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadegorduratotal">{{Number(alimento.quantidadegorduratotal).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadeenergia">{{Number(alimento.quantidadeenergia).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminaa">{{Number(alimento.quantidadevitaminaa).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadeferro">{{Number(alimento.quantidadeferro).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadecalcio">{{Number(alimento.quantidadecalcio).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadefibratotal">{{Number(alimento.quantidadefibratotal).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadegordurapolisaturada" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadegordurapolisaturada).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadegorduramonosaturada" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadegorduramonosaturada).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadegordurasaturada" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadegordurasaturada).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadefibrasoluvel" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadefibrasoluvel).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadefibrainsoluvel" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadefibrainsoluvel).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadecolesterol" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadecolesterol).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminab1" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminab1).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminab2" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminab2).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminab3" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminab3).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminab5" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminab5).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminab6" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminab6).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminab9" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminab9).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminab12" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminab12).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminac" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminac).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminad" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminad).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadevitaminae" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadevitaminae).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadeiodo" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadeiodo).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadesodio" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadesodio).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidademagnesio" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidademagnesio).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadezinco" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadezinco).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidademanganes" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidademanganes).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadepotassio" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadepotassio).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadefosforo" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadefosforo).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadecobre" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadecobre).toFixed(3)}}</td>
                <td class="text-align__center" :title="alimento.quantidadeselenio" v-show="mostrarTabelaCompleta">{{Number(alimento.quantidadeselenio).toFixed(3)}}</td>
                <td style="min-width: 120px;">
                  <v-btn :disabled="modoTela == 'edicao' || loading" icon title="Editar" @click="alterarAlimentoDaPreparacao(alimento)" >
                    <v-icon class="btn-acoes-icon">edit</v-icon>
                  </v-btn>
                  <v-btn :disabled="modoTela == 'edicao' || loading" icon title="Excluir" @click="excluirAlimentoDaPreparacao(alimento.identificadorcomposicaoalimento)">
                    <v-icon color="red">delete_forever</v-icon>
                  </v-btn>
                </td>
              </tr>

            </template>

          </tbody>
          <tfoot v-if="(composicao.length > 0)">
            <tr style="font-weight: 900;">
              <td style="padding-left:5px;">Total:</td>
              <td></td>
              <td></td>
              <td class="text-align__center" style="padding: 12px 0px;">{{valoresTotais[1].toFixed(3)}}</td>
              <td class="text-align__center">{{valoresTotais[6].toFixed(3)}}</td>
              <td class="text-align__center">{{valoresTotais[2].toFixed(3)}}</td>
              <td class="text-align__center"><span style="padding: 5px 10px;border-radius: 5px;background-color: #ddcab2;">{{valoresTotais[0].toFixed(3)}}</span></td>
              <td class="text-align__center">{{valoresTotais[11].toFixed(3)}}</td>
              <td class="text-align__center">{{valoresTotais[30].toFixed(3)}}</td>
              <td class="text-align__center">{{valoresTotais[24].toFixed(3)}}</td>
              <td class="text-align__center">{{valoresTotais[7].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[3].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[4].toFixed(3)}}</td>

              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[5].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[8].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[9].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[10].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[12].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[13].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[14].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[15].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[16].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[17].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[18].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[19].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[20].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[21].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[22].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[23].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[25].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[26].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[27].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[28].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[29].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[31].toFixed(3)}}</td>
              <td class="text-align__center" v-show="mostrarTabelaCompleta">{{valoresTotais[32].toFixed(3)}}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
          </v-flex>
        </v-layout>
        <v-layout row justify-space-between align-center>
          <v-flex xs2>

            <!-- <v-btn type="button"  color="cyan" :dark="!loading" :disabled="modoTela == 'edicao' || loading" title="Exportar XLSX" @click="exportToXLSX"> -->
              <!-- <v-icon color="cyan">delete_forever</v-icon> -->
              <!-- Exportar para XLSX -->
            <!-- </v-btn> -->
          </v-flex>
          <v-flex xs2>
            <v-switch style="float:right;margin-right:0px;" v-model="mostrarTabelaCompleta" label="Detalhar" color="cyan" ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { alphaNumSpace } from '@/validations';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const PreparacaoRepository = RepositoryFactory.get("preparacao");
const AlimentoRepository = RepositoryFactory.get("alimento");
const ComposicaoPreparacaoRepository = RepositoryFactory.get("composicaoPreparacao");

//import { read, writeFileXLSX } from "xlsx";
//import XLSX from 'xlsx'

const setFormInicial = () => ({
  identificadorpreparacao: '',
  descricaopreparacao: '',
  quantidade: '',
  unidade: null,
  complemento: null,
  alimento: {
    identificadorcomposicaoalimentopadrao: '',
    indicaorigemalimentoexterno: '',
    quantidadecarboidrato: '',
    quantidadeproteina: '',
    quantidadegorduratotal: '',
    quantidadeenergia: '',
    quantidadevitaminaa: '',
    quantidadeferro: '',
    quantidadecalcio: '',
    quantidadefibratotal: '',
    quantidadegordurapolisaturada: '',
    quantidadegorduramonosaturada: '',
    quantidadegordurasaturada: '',
    quantidadefibrasoluvel: '',
    quantidadefibrainsoluvel: '',
    quantidadecolesterol: '',
    quantidadevitaminac: '',
    quantidadevitaminab1: '',
    quantidadevitaminab2: '',
    quantidadevitaminab6: '',
    quantidadevitaminab12: '',
    quantidadevitaminad: '',
    quantidadevitaminab3: '',
    quantidadevitaminab9: '',
    quantidadevitaminab5: '',
    quantidadevitaminae: '',
    quantidadeiodo: '',
    quantidadesodio: '',
    quantidademagnesio: '',
    quantidadezinco: '',
    quantidademanganes: '',
    quantidadepotassio: '',
    quantidadefosforo: '',
    quantidadecobre: '',
    quantidadeselenio: '',
    complemento: null,
  }
});

export default {
  name: 'ComposicaoPreparacao',
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      formUltimo: {},
      loading: false,
      mostrarTabelaCompleta: false,
      preparacaoOptions: [],
      alimentoOptions: [],
      unidadeOptions: [
        { key: 1, value: 'ml'},
        { key: 2, value: 'g'}
      ],
      complementoOptions: [
        { key: 1, value: 'Calda'},
        { key: 2, value: 'Recheio'},
        { key: 3, value: 'Molho'}
      ],
      alimentos: [],
      composicao: [],
      modoTela: 'adicao',
      alimentoEmEdicao: null,
      preparacoesLoading: false,
      preparacaoSearch: '',
      alimentosLoading: false,
      alimentoSearch: '',
    };
  },

  validations: {
    form: {
      descricaopreparacao: { required, alphaNumSpace, maxLength: maxLength(100) },
      identificadorpreparacao: { required },
      alimento: {identificadorcomposicaoalimentopadrao: { required } },
      quantidade: { required },
      unidade: { required },
      complemento: { required }
    }
  },

  mounted: function() {
    this.$Progress.finish();
  },

  methods: {
    tabelaPreparacao() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Preparação / Listar',
          rota_api: 'merenda/preparacao/tabela',
          headers: [{ text: 'Identificador', value: 'identificadorpreparacao', sortable: false },
						          { text: 'Grupo de Preparação', value: 'descricaogrupopreparacao', sortable: false },
                      { text: 'Descrição', value: 'descricaopreparacao', sortable: false },
                      { text: 'Estação', value: 'indicainvernoverao', sortable: false },],
        },
      });
    },
    novaPreparacao() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarPreparacao() {
      this.acao = 'editar';
    },
    cancelarPreparacao() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirPreparacao() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta preparação?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await PreparacaoRepository.deletarPreparacao(this.form.identificadorpreparacao);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
    },

    async carregarComposicaoPreparacao() {
      try {
        this.loading = true;
        this.$Progress.start();
        this.composicao = [];

        let buscaAlimento = AlimentoRepository.buscarAlimento();
        let buscaComposicaoPreparacao = ComposicaoPreparacaoRepository.buscarComposicaoPreparacao(this.form.identificadorpreparacao);

        const [{ data: alimentos}, { data: composicao }] = await Promise.all([buscaAlimento, buscaComposicaoPreparacao]);

        await this.carregaAlimento(alimentos.results)

        this.submitText = composicao.message;
        this.snackbar = true;
        this.msgArrayError = [];

        this.composicao = [];

        composicao.results.forEach( (alimento) => {
          let desc = this.alimentoOptions.filter(a => a.key == alimento.identificadorcomposicaoalimentopadrao)[0].value
          let dsunidade = this.unidadeOptions.filter(u => u.key == alimento.unidademedidaalimento)[0].value
          let dsfonte = this.alimentos.filter(a => a.identificadorcomposicaoalimentopadrao == alimento.identificadorcomposicaoalimentopadrao)[0].indicaorigemalimentoexterno
          this.composicao.push({ quantidade: alimento.quantidadepercapita, unidade: dsunidade, indicaorigemalimentoexterno: dsfonte, complemento: alimento.identificadorcomplementacaopreparacao, ...alimento, descricaocomposicaoalimentopadrao: desc})
        })

        this.$v.$reset()
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }

      } finally {
        this.loading = false;
        this.$Progress.finish();
      }
    },

    alterarAlimentoDaPreparacao(alimento) {
      this.modoTela = 'edicao'
      this.form.alimento.identificadorcomposicaoalimentopadrao = alimento.identificadorcomposicaoalimentopadrao
      this.form.quantidade = alimento.quantidade
      this.form.unidade = this.unidadeOptions.filter( u => u.value == alimento.unidade)[0].key
      this.form.complemento = alimento.complemento
      this.alimentoEmEdicao = alimento.identificadorcomposicaoalimento
    },

    async excluirAlimentoDaPreparacao( identificadorcomposicaoalimento ) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este alimento?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          this.loading = true;
          this.$Progress.start();

          const { data } = await ComposicaoPreparacaoRepository.deletarComposicaoPreparacao(identificadorcomposicaoalimento);

          this.submitText = data.message;
          this.snackbar = true;
          this.msgArrayError = [];

          this.composicao = this.composicao.filter( alimento => alimento.identificadorcomposicaoalimento != identificadorcomposicaoalimento)
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        } finally {
          this.loading = false;
          this.$Progress.finish();
        }
      }
    },

    async salvarEdicaoAlimento(identificadorcomposicaoalimento) {
      let alimentoEmEdicao = this.composicao.filter( alimento => alimento.identificadorcomposicaoalimento == identificadorcomposicaoalimento)

      if (alimentoEmEdicao.length > 0 ) {
        alimentoEmEdicao = alimentoEmEdicao[0]
        alimentoEmEdicao.quantidade = this.form.quantidade
        alimentoEmEdicao.unidade = this.unidadeSelecionada()


        let alimento = this.alimentos.filter( a => a.identificadorcomposicaoalimentopadrao == this.form.alimento.identificadorcomposicaoalimentopadrao)
        alimento = alimento[0]

        alimentoEmEdicao.quantidadecarboidrato = (parseFloat(alimento.quantidadecarboidrato) * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadeproteina = (alimento.quantidadeproteina * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadegorduratotal = (alimento.quantidadegorduratotal * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadeenergia = (alimento.quantidadeenergia * parseFloat(this.form.quantidade) / 100)
        alimentoEmEdicao.quantidadevitaminaa = (alimento.quantidadevitaminaa * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadeferro = (alimento.quantidadeferro * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadecalcio = (alimento.quantidadecalcio * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadefibratotal = (alimento.quantidadefibratotal * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadegordurapolisaturada = (alimento.quantidadegordurapolisaturada * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadegorduramonosaturada = (alimento.quantidadegorduramonosaturada * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadegordurasaturada = (alimento.quantidadegordurasaturada * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadefibrasoluvel = (alimento.quantidadefibrasoluvel * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadefibrainsoluvel = (alimento.quantidadefibrainsoluvel * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadecolesterol = (alimento.quantidadecolesterol * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminab1 = (alimento.quantidadevitaminab1 * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminab2 = (alimento.quantidadevitaminab2 * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminab3 = (alimento.quantidadevitaminab3 * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminab5 = (alimento.quantidadevitaminab5 * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminab6 = (alimento.quantidadevitaminab6 * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminab9 = (alimento.quantidadevitaminab9 * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminab12 = (alimento.quantidadevitaminab12 * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminac = (alimento.quantidadevitaminac * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminad = (alimento.quantidadevitaminad * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadevitaminae = (alimento.quantidadevitaminae * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadeiodo = (alimento.quantidadeiodo * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadesodio = (alimento.quantidadesodio * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidademagnesio = (alimento.quantidademagnesio * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadezinco = (alimento.quantidadezinco * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidademanganes = (alimento.quantidademanganes * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadepotassio = (alimento.quantidadepotassio * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadefosforo = (alimento.quantidadefosforo * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadecobre = (alimento.quantidadecobre * parseFloat(this.form.quantidade) / 100).toFixed(3)
        alimentoEmEdicao.quantidadeselenio = (alimento.quantidadeselenio * parseFloat(this.form.quantidade) / 100).toFixed(3)

        try {
          this.loading = true;
          this.$Progress.start();

          const { data } = await ComposicaoPreparacaoRepository.editarComposicaoPreparacao( { ...alimentoEmEdicao, quantidadepercapita: alimentoEmEdicao.quantidade, unidademedidaalimento: this.form.unidade} );

          this.submitText = data.message;
          this.snackbar = true;
          this.msgArrayError = [];

          this.$v.$reset()
        } catch (error) {
          if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
          if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }

        } finally {
          this.loading = false;
          this.$Progress.finish();
        }
      }
      this.cancelarAlteracao()
    },

    cancelarAlteracao() {
      this.modoTela = 'adicao'
      this.form.alimento.identificadorcomposicaoalimentopadrao = null
      this.form.quantidade = ''
      this.form.unidade = null
      this.form.complemento = null
      this.alimentoEmEdicao = null
      this.$v.$reset();
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        const { data } = await PreparacaoRepository[this.acao === 'novo' ? 'criarPreparacao' : 'editarPreparacao'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };

      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }

      this.$v.$reset();
    },
    async encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
      this.$refs.buscaSimpleApi.lista = [];
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
    async carregaPreparacao(){
      if (this.preparacaoOptions.length) {
        return
      }

      try {
        this.preparacoesLoading = true;
        const { data } = await PreparacaoRepository.buscarPreparacao();
        for (const key of data.results) {
          this.preparacaoOptions.push({value: key.identificadorpreparacao , text: key.descricaopreparacao })
        }
      } catch (e) {
      } finally {
        this.preparacoesLoading = false
      }
    },
    async carregaAlimento(alimentos){
      this.alimentos = alimentos
      for (const key of alimentos) {
        this.alimentoOptions.push({key: key.identificadorcomposicaoalimentopadrao , value: key.descricaocomposicaoalimentopadrao })
      }
    },
    async adicionarAlimento() {
      // if (this.alimentoJaAdicionado()) {
      //   const ntfExcluir = await this.$sgal({
      //     title: 'Não foi possível!',
      //     text: 'Alimento já incluso na composição.',
      //     type: 'notification',
      //   });
      //   return
      // }

      let alimento = this.alimentos.filter( a => a.identificadorcomposicaoalimentopadrao == this.form.alimento.identificadorcomposicaoalimentopadrao)
      alimento = { ...alimento[0] }

      alimento.quantidadecarboidrato = (alimento.quantidadecarboidrato * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadeproteina = (alimento.quantidadeproteina * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadegorduratotal = (alimento.quantidadegorduratotal * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadeenergia = (alimento.quantidadeenergia * parseFloat(this.form.quantidade) / 100)
      alimento.quantidadevitaminaa = (alimento.quantidadevitaminaa * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadeferro = (alimento.quantidadeferro * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadecalcio = (alimento.quantidadecalcio * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadefibratotal = (alimento.quantidadefibratotal * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadegordurapolisaturada = (alimento.quantidadegordurapolisaturada * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadegorduramonosaturada = (alimento.quantidadegorduramonosaturada * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadegordurasaturada = (alimento.quantidadegordurasaturada * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadefibrasoluvel = (alimento.quantidadefibrasoluvel * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadefibrainsoluvel = (alimento.quantidadefibrainsoluvel * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadecolesterol = (alimento.quantidadecolesterol * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminab1 = (alimento.quantidadevitaminab1 * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminab2 = (alimento.quantidadevitaminab2 * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminab3 = (alimento.quantidadevitaminab3 * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminab5 = (alimento.quantidadevitaminab5 * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminab6 = (alimento.quantidadevitaminab6 * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminab9 = (alimento.quantidadevitaminab9 * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminab12 = (alimento.quantidadevitaminab12 * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminac = (alimento.quantidadevitaminac * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminad = (alimento.quantidadevitaminad * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadevitaminae = (alimento.quantidadevitaminae * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadeiodo = (alimento.quantidadeiodo * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadesodio = (alimento.quantidadesodio * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidademagnesio = (alimento.quantidademagnesio * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadezinco = (alimento.quantidadezinco * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidademanganes = (alimento.quantidademanganes * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadepotassio = (alimento.quantidadepotassio * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadefosforo = (alimento.quantidadefosforo * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadecobre = (alimento.quantidadecobre * parseFloat(this.form.quantidade) / 100).toFixed(3)
      alimento.quantidadeselenio = (alimento.quantidadeselenio * parseFloat(this.form.quantidade) / 100).toFixed(3)

      try {
        this.loading = true;
        this.$Progress.start();
        this.msgArrayError = []

        const { data } = await ComposicaoPreparacaoRepository.inserirComposicaoPreparacao( {identificadorpreparacao: this.form.identificadorpreparacao, quantidadepercapita: this.form.quantidade, unidademedidaalimento: this.form.unidade, identificadorcomplementacaopreparacao: this.form.complemento, ...alimento} );

        this.submitText = data.message;
        alimento.identificadorcomposicaoalimento = data.results.identificadorcomposicaoalimento;
        this.snackbar = true;
        this.msgArrayError = [];

        this.composicao.push({ quantidade: this.form.quantidade, unidade: this.unidadeSelecionada(), complemento: this.form.complemento, ...alimento})

        this.form.alimento.identificadorcomposicaoalimentopadrao = null
        this.form.quantidade = ''
        this.form.unidade = null

        this.$v.$reset()
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }

      } finally {
        this.loading = false;
        this.$Progress.finish();
      }
    },
    alimentoJaAdicionado() {
      let idAlimentoSendoAdicionado = this.form.alimento.identificadorcomposicaoalimentopadrao
      let idComplementacao = this.form.complemento

      let alimentoProcurado = this.composicao.find( alimento => alimento.identificadorcomposicaoalimentopadrao == idAlimentoSendoAdicionado &&
        alimento.complemento == idComplementacao
      )

      if (alimentoProcurado) {
        return true
      }

      return false

    },
    unidadeSelecionada() {
      let unidade = this.unidadeOptions.filter( u => u.key == this.form.unidade)
      if (unidade.length == 0) return null
      return unidade[0].value
    },
    exportToXLSX() {
      // var ws = XLSX.utils.table_to_sheet(document.getElementById("composicao_preparacao_table"));
      // delete (ws['AK1'])
      // for (var i = 0; i < document.querySelector("#composicao_preparacao_table tbody").childElementCount; i++) {
      //   delete (ws['AK' + (i+2)])
      // }
      // const wb = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      // XLSX.writeFile(wb, "Composicao_Preparacao.xlsx");
    }
  },

  computed: {
    valoresTotais() {

      return this.composicao.reduce( (total, alimento) => {
        return [
          total[0]  + parseFloat(alimento.quantidadeenergia),
          total[1]  + parseFloat(alimento.quantidadecarboidrato),
          total[2]  + parseFloat(alimento.quantidadegorduratotal),
          total[3]  + parseFloat(alimento.quantidadegordurapolisaturada),
          total[4]  + parseFloat(alimento.quantidadegorduramonosaturada),
          total[5]  + parseFloat(alimento.quantidadegordurasaturada),
          total[6]  + parseFloat(alimento.quantidadeproteina),
          total[7]  + parseFloat(alimento.quantidadefibratotal),
          total[8]  + parseFloat(alimento.quantidadefibrasoluvel),
          total[9]  + parseFloat(alimento.quantidadefibrainsoluvel),
          total[10]  + parseFloat(alimento.quantidadecolesterol),
          total[11]  + parseFloat(alimento.quantidadevitaminaa),
          total[12]  + parseFloat(alimento.quantidadevitaminab1),
          total[13]  + parseFloat(alimento.quantidadevitaminab2),
          total[14]  + parseFloat(alimento.quantidadevitaminab3),
          total[15]  + parseFloat(alimento.quantidadevitaminab5),
          total[16]  + parseFloat(alimento.quantidadevitaminab6),
          total[17]  + parseFloat(alimento.quantidadevitaminab9),
          total[18]  + parseFloat(alimento.quantidadevitaminab12),
          total[19]  + parseFloat(alimento.quantidadevitaminac),
          total[20]  + parseFloat(alimento.quantidadevitaminad),
          total[21]  + parseFloat(alimento.quantidadevitaminae),
          total[22]  + parseFloat(alimento.quantidadeiodo),
          total[23]  + parseFloat(alimento.quantidadesodio),
          total[24]  + parseFloat(alimento.quantidadecalcio),
          total[25]  + parseFloat(alimento.quantidademagnesio),
          total[26]  + parseFloat(alimento.quantidadezinco),
          total[27]  + parseFloat(alimento.quantidademanganes),
          total[28]  + parseFloat(alimento.quantidadepotassio),
          total[29]  + parseFloat(alimento.quantidadefosforo),
          total[30]  + parseFloat(alimento.quantidadeferro),
          total[31]  + parseFloat(alimento.quantidadecobre),
          total[32]  + parseFloat(alimento.quantidadeselenio),
        ]
      }, [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])
    }
  },

  watch: {
    'form.quantidade'(newValue) {
      this.form.quantidade = newValue.toString().replace(',', '.')
    }
  }
};
</script>

<style scoped>
.container.grid-list-lg .layout .flex {
    padding: 0px 8px;
}
.text-align__center {
  text-align: center;
}
.table-siged thead tr th {
  text-transform: none;
}
.input-block { width: 100%; }
@media only screen and (max-width: 700px) {
  .select-ajax {
      width: 100%;
  }
}
</style>
